import './oiModal.css';
import React from 'react';

const oiModal = (props) => {
    return (
        <div id="oi-modal-layer">

            <div id="oi-modal">

                <h3>{props.modal.title}</h3>

                <div id="oi-modal-text-box">

                    <p>{props.modal.text}</p>

                    {props.modal.btn1 ?
                        <button id="oi-btn-confirm"
                            onClick={props.modal.event1}>{props.modal.btn1}</button>
                        : ''}

                    {props.modal.btn2 ?
                        <button id="oi-btn-cancel"
                            onClick={props.modal.event2}>{props.modal.btn2}</button>
                        : ''}

                </div>

            </div>

        </div>
    );
};

export default oiModal;


// WEBPACK FOOTER //
// ./src/components/oiModal/oiModal.js